import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PageLoaderService } from '../../../util/pageloader.service';
import { OrderService } from './order.service';

import * as OrderActions from './order.actions';
import { catchError, finalize, map, of, switchMap } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class OrderEffects {
  private actions$ = inject(Actions);
  private pageLoaderService = inject(PageLoaderService);
  private orderService = inject(OrderService);


  placeOrder$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(OrderActions.placeOrder.type),
      switchMap((action: any) => {
        this.pageLoaderService.open();
        return this.orderService.create(action.order).pipe(
          map((response) =>
            OrderActions.placeOrderSuccess({
              response,
            })
          ),
          catchError((err: HttpErrorResponse) => {
            return of(OrderActions.placeOrderFailed({ err }));
          }),
          finalize(() => this.pageLoaderService.close())
        );
      })
    );
  });

  processPayment$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(OrderActions.processPayment.type),
      switchMap((action: any) => {
        this.pageLoaderService.open();
        return this.orderService
          .processPayment(action.orderId, action.payment)
          .pipe(
            map((response) =>
              OrderActions.processSuccess({
                response,
              })
            ),
            catchError((err: HttpErrorResponse) => {
              return of(OrderActions.processPaymentFailed({ err }));
            }),
            finalize(() => this.pageLoaderService.close())
          );
      })
    );
  });
}
